import { useState } from 'react';
import { Button, ErrorNote, ui } from '@/components/ui';
import { mfaService } from '@/services/api';
import { CodeInput } from './CodeInput';

// Shown after a correct password (or Google/Apple) when the account has two-step verification.
export function MfaLoginStep({
  challenge,
  onSignedIn,
  onCancel,
}: {
  challenge: string;
  onSignedIn: () => Promise<void>;
  onCancel: () => void;
}) {
  const [code, setCode] = useState('');
  const [error, setError] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);
  return (
    <form
      className={ui.stack}
      onSubmit={(e) => {
        e.preventDefault();
        setBusy(true);
        setError(null);
        mfaService
          .completeLogin(challenge, code)
          .then(onSignedIn)
          .catch((err: unknown) => {
            setError(err);
            setCode('');
          })
          .finally(() => {
            setBusy(false);
          });
      }}
    >
      <p>Enter the 6-digit code from your authenticator app.</p>
      <div className={ui.field}>
        <label htmlFor="mfa-login-code">Code</label>
        <CodeInput id="mfa-login-code" value={code} onChange={setCode} autoFocus />
        <span className={ui.hint}>Lost your phone? Enter one of your recovery codes instead.</span>
      </div>
      <ErrorNote error={error} />
      <div className={ui.row}>
        <Button type="submit" disabled={busy}>
          Verify
        </Button>
        <Button variant="ghost" onClick={onCancel}>
          Back
        </Button>
      </div>
    </form>
  );
}
